import TileContainer from 'components/shared/tiles/TileContainer';
import { CONFIGURE_VIEW } from 'constants/constants';
import { Fade } from 'react-awesome-reveal';
import { useParams } from 'react-router-dom';
import Layout from '../../layout/Layout';
import ConfigureViewHeader from './configure-view/ConfigureViewHeader';

const TileLayout = () => {
  const { type } = useParams();
  const page =
    type === 'sampleview' ? CONFIGURE_VIEW.myDefault : CONFIGURE_VIEW?.myView;

  return (
      <Layout showRighSideBar={false}>
        <Fade direction='left'>
          <div className='gne-container'>
            <ConfigureViewHeader page={page} />

            <TileContainer page={page} />
          </div>
        </Fade>
      </Layout>
  );
};

export default TileLayout;
